/**
 * check the status of the response object
 * @param  {object} response fetch response object
 * @return {object}          response object if valid
 */
export default function checkStatus(response) {
  if (200 <= response.status && 300 > response.status) {
    return response;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}



// WEBPACK FOOTER //
// ./app/utils/http/checkStatus.js